var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20.8962C22 21.5059 21.5057 22.0001 20.8962 22.0001H3.10383C2.49406 22.0001 2 21.5059 2 20.8962V3.10383C2 2.49414 2.49406 2 3.10383 2H20.8962C21.5057 2 22 2.49414 22 3.10383V20.8962ZM15.7996 14.255V22.0001H12.6826V14.255H10.0762V11.2366H12.6826V9.01061C12.6826 6.42733 14.2603 5.02069 16.5648 5.02069C17.6686 5.02069 18.6173 5.10288 18.8939 5.13968V7.83928L17.2955 7.83999C16.0423 7.83999 15.7996 8.43553 15.7996 9.30944V11.2366H18.7886L18.3994 14.255H15.7996Z",
    fill: "#365899"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.94286afe75097991edf3293cfbfd1102.svg";
export { ForwardRef as ReactComponent };